import { store } from '@/store'
import DynamicModuleRegistrationUtil from '@/utils/dynamicModuleRegistration'
import { BaseRouteEnum } from '@/enums/modules/routes'
import PricingRoot from '@/components/micro-front-ends/Pricing'
import Admin from '@/components/admin/Admin'

// Vuex Modules to load
const AdminModule = () => import(/* webpackChunkName: "Admin" */ '@/store/modules/admin')

// ******************************************************
// *************** Route Guard Functions ****************
// ******************************************************

const dynamicModuleRegistrationArgsAdmin = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'admin',
    module: AdminModule,
    store,
    modulePath: 'admin'
  }
}

const checkIfUserIsAdmin = () => {
  var user = store.getters['user/getUser']
  return user.isAdmin
}

// ******************************************************
// ****************** Route Definitions *****************
// ******************************************************

export default [
  {
    path: '/Admin',
    component: {
      render (createElement) {
        if (store.getters.isPricingMFEEnabled) {
          return createElement(PricingRoot, { props: { path: '/pricing/admin' } })
        } else {
          return createElement(Admin)
        }
      }
    },
    name: 'Admin',
    meta: { showSideNav: true },
    async beforeEnter (to, from, next) {
      if (checkIfUserIsAdmin()) {
        await DynamicModuleRegistrationUtil(dynamicModuleRegistrationArgsAdmin())
        next()
      } else {
        next({ name: BaseRouteEnum.FourOhFour })
      }
    }
  }
]
